import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import Picture from '../Picture'
import Icon from '../Icon'

export const Container = styled(Link)`
  position: relative;
  display: flex;
  color: ${({ theme }) => theme.colors.black};
  overflow: hidden;
`
export const _Picture = styled(Picture)`
  position: relative;
  z-index: 1;
  width: 100%;
  transition: transform 0.3s ease-in-out;
  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  ${Container}:is(a):focus &,
  ${Container}:is(a):hover & {
    transform: scale(1.05);
  }
`
type InfosProps = {
  $largeOnMobile?: boolean
  $noText?: boolean
  $color?: string
}
export const Infos = styled.span<InfosProps>`
  --width: ${({ $largeOnMobile }) =>
    $largeOnMobile ? pxToRem(290) : pxToRem(250)};
  --padding--end: ${pxToRem(44)};
  --padding--other: ${pxToRem(12)};
  position: absolute;
  z-index: 2;
  inset: auto 0 0 auto;
  display: flex;
  flex-flow: column;
  width: 100%;
  max-width: min(95%, var(--width));
  padding-block: var(--padding--other);
  padding-inline-start: var(--padding--other);
  padding-inline-end: var(--padding--end);
  background: ${({ theme }) => theme.colors.white};
  transition: background-color 0.3s ease-in-out;
  ${Container}:is(a):focus &,
  ${Container}:is(a):hover & {
    background: ${({ $color }) => $color};
    color: ${({ $color, theme }) =>
      $color === theme.colors.black ? theme.colors.white : theme.colors.black};
  }
  &[data-notext] {
    aspect-ratio: 1;
    width: auto;
    max-width: none;
  }
  &:empty {
    display: none;
  }
  @media ${mq(sizes.desktop)} {
    --width: ${pxToRem(300)};
    --padding--end: ${pxToRem(48)};
    --padding--other: ${pxToRem(16)};
  }
`
export const Name = styled.span`
  ${({ theme }) => theme.textStyles.m375_h3}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h3}
  }
`
export const Status = styled.span`
  ${({ theme }) => theme.textStyles.m375_body}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
  }
`
export const Arrow = styled(Icon)`
  --translate__portrait: ${pxToRem(8)};
  position: absolute;
  inset-inline-end: var(--padding--other);
  top: 50%;
  transform: translate(0, -50%);
  aspect-ratio: 1;
  width: ${pxToRem(24)};
  transition: transform 0.3s ease-in-out;
  ${Container}:is(a):focus &,
  ${Container}:is(a):hover & {
    transform: translate(var(--translate__portrait), -50%);
  }
  ${Infos}[data-notext] & {
    --translate__portrait: ${pxToRem(4)};
  }
`
